import React from 'react'
import { useTranslation } from 'react-i18next'

const LanguageSelect = ({ languages }: { languages: { id: number; name: string; label: string; code: string }[] }) => {
  const { i18n } = useTranslation()
  return (
    <>
      <label className="text-gray-600 mt-3 block text-h1 font-bold">Language</label>
      <select
        className="mt-2 w-full rounded-lg"
        onChange={(e) => {
          i18n.changeLanguage(e.target.value)
        }}
        defaultValue={i18n.language}
      >
        {languages.map((v, idx) => {
          return <option value={v.code}>{v.label}</option>
        })}
      </select>
    </>
  )
}

export default LanguageSelect
